<template lang="pug">
  .coordinates-modal
    .modal
      .modal__container.coordinates-modal__container
        .modal__header
          .modal__title Координаты
          button.reset-btn.close(@click.self="close")
        .modal__body
          e-form(:formValidator="formValidator" formClass="coordinates-modal__form")
            .coordinates-modal__points
              .coordinates-modal__row(v-for="point in points" :key="point.id")
                .coordinates-modal__col
                  e-form-subtitle(text="Долгота")
                  .modal__row
                    .modal__col
                      e-form-group(
                        label="градусы"
                        name="latitudeDegrees"
                        inputType="input"
                        type="number"
                        :min="0"
                        :model="point"
                        tabView="tab1"
                      )
                    .modal__col
                      e-form-group(
                        label="минуты"
                        name="latitudeMinutes"
                        inputType="input"
                        type="number"
                        :min="0"
                        :model="point"
                        tabView="tab1"
                      )
                    .modal__col
                      e-form-group(
                        label="секунды"
                        name="latitudeSeconds"
                        inputType="input"
                        type="number"
                        :min="0"
                        :model="point"
                        tabView="tab1"
                      )
                .coordinates-modal__col
                  e-form-subtitle(text="Широта")
                  .modal__row
                    .modal__col
                      e-form-group(
                        label="градусы"
                        name="longitudeDegrees"
                        inputType="input"
                        type="number"
                        :min="0"
                        :model="point"
                        tabView="tab1"
                      )
                    .modal__col
                      e-form-group(
                        label="минуты"
                        name="longitudeMinutes"
                        inputType="input"
                        type="number"
                        :min="0"
                        :model="point"
                        tabView="tab1"
                      )
                    .modal__col
                      e-form-group(
                        label="секунды"
                        name="longitudeSeconds"
                        inputType="input"
                        type="number"
                        :min="0"
                        :model="point"
                        tabView="tab1"
                      )
                .coordinates-modal__col
                  button.reset-btn.button.button_small.button_delete.button_icon(@click="deleteRow(point)")
          .coordinates-modal__buttons
            button.reset-btn.button(@click="circleCoordinates") Замкнуть полигон
            button.reset-btn.button(@click="addPoint") Добавить точку
        .modal__footer
          .actions-filter-panel.actions-filter-panel--right
            div
              button(type="button" @click="close()").reset-btn.button.button_no-border.button_color.modal__button Отмена
              button(type="button" @click="setCoordinates" :disabled="addDisabled" v-if="!editableCoords.length" ).button.reset-btn.button_save Добавить зону
              button(type="button" @click="editCoordinates" v-else).button.reset-btn.button_save Редактировать зону
</template>

<script>
import formBaseMixin from '@/components/form/form-base-mixin'
import { convertDecimalToDms } from '../../../utils/coordinates'

const Point = (id) => ({
  id,
  latitudeDegrees: '',
  latitudeMinutes: '',
  latitudeSeconds: '',
  longitudeDegrees: '',
  longitudeMinutes: '',
  longitudeSeconds: '',
})

export default {
  mixins: [formBaseMixin],
  props: {
    editableCoords: {
      type: Array,
    },
  },
  data() {
    return {
      points: [new Point(1)],
      fields: {
        tabView: 'tab1',
      },
      addDisabled: true,
    }
  },
  methods: {
    close() {
      this.$emit('closeForm')
    },
    setCoordinates() {
      this.$emit('setCoordinates', this.points)
    },
    editCoordinates() {
      this.$emit('editCoordinates', this.points)
    },
    deleteRow(point) {
      const index = this.points.findIndex((item) => item.id === point.id)
      this.points.splice(index, 1)
    },
    addPoint() {
      const point = new Point(this.points.length + 1)
      this.$set(this.points, this.points.length, point)
    },
    circleCoordinates() {
      const firstPoint = this.points[0]
      const point = { ...firstPoint, id: this.points.length + 1 }
      this.$set(this.points, this.points.length, point)
      let haveCoordinates = false
      this.points.forEach((item) => {
        Object.values(item).forEach((el) => {
          if (el !== '') haveCoordinates = true
        })
      })
      if (haveCoordinates) {
        this.addDisabled = false
      }
    },
    setEditablePoints(points) {
      this.points = []
      points.forEach((point, index) => {
        const {
          degrees: latitudeDegrees,
          minutes: latitudeMinutes,
          seconds: latitudeSeconds,
        } = convertDecimalToDms(point[0])
        const {
          degrees: longitudeDegrees,
          minutes: longitudeMinutes,
          seconds: longitudeSeconds,
        } = convertDecimalToDms(point[1])
        const newPoint = {
          id: index + 1,
          latitudeDegrees,
          latitudeMinutes,
          latitudeSeconds,
          longitudeDegrees,
          longitudeMinutes,
          longitudeSeconds,
        }
        this.points.push(newPoint)
      })
      const firstPoint = points[0]
      const lastPoint = points.at(-1)

      if (
        firstPoint.latitudeDegrees === lastPoint.latitudeDegrees &&
        firstPoint.latitudeMinutes === lastPoint.latitudeMinutes &&
        firstPoint.latitudeSeconds === lastPoint.latitudeSeconds &&
        firstPoint.longitudeDegrees === lastPoint.longitudeDegrees &&
        firstPoint.longitudeMinutes === lastPoint.longitudeMinutes &&
        firstPoint.longitudeSeconds === lastPoint.longitudeSeconds
      ) {
        this.addDisabled = false
      }
    },
  },
  created() {
    if (this.editableCoords.length) {
      this.setEditablePoints(this.editableCoords)
    }
  },
}
</script>

<style scoped lang="scss">
@import '../../../assets/scss/utils/variables';
@import '../../../assets/scss/utils/mixins';

.coordinates-modal {
  &__container {
    max-width: 50%;
    min-width: 700px;
  }

  &__row {
    display: flex;
    align-items: flex-end;
    gap: 20px;

    &:not(:last-child) {
      margin-bottom: 20px;
    }
  }

  &__form {
    margin-bottom: 20px;
  }

  &__buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__points {
    max-height: 500px;
    overflow: hidden;
    overflow-y: scroll;
    @include scrollbars();
  }
}
</style>
